module.exports = __webpack_public_path__ + "img/日本东京大学.644debb5.jpg";